export default "__VITE_ASSET__CYFCGF92__"